import { Sponsor } from 'globals/store/sponsors.data';
import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { tableFilterTypes, CHANGE_TABLE_FILTERS, performersFeature, performerActions } from './performers.era';
import { AllSameKeyValuesEnforcer } from './../helpers/helpers';
import { Ranking } from 'globals/store/events.data';
import { createActionGroup, createReducer, on } from '@ngrx/store';
import { eventsActions } from './events.era';
import { makeMapFromListOfObjectsAndKey } from 'globals/helpers/helpers';
import { selectAll, selectEntities } from './accounts.era';

// This file may well just be a source of models for the new performer module for now.


export interface SponsorsState extends EntityState<Sponsor> {
  sponsorFilterType: string
  sponsorTypes: { [id:string]: Ranking }
}

interface SponsorDisplayTypes { readOnly, widePod, narrowPod, staticCard }
export const sponsorDisplayTypes: AllSameKeyValuesEnforcer<SponsorDisplayTypes> = { readOnly: 'readOnly', widePod: 'widePod', narrowPod: 'narrowPod', staticCard: 'staticCard' }

const getDefaultSponsors= (): SponsorsState => ({
  ids: [],
  entities: {},
  sponsorFilterType: tableFilterTypes.NoFilters,
  sponsorTypes: {}
})

const adapter = createEntityAdapter<Sponsor>()
const makeInitialState = (): SponsorsState => adapter.getInitialState(getDefaultSponsors())


export const sponsorsActions = createActionGroup({
  source: 'Sponsors',
  events: {
    "Change Table Filters": (filterType: string) => ({ filterType })
   }
})
export const sponsorsReducer = createReducer(
  makeInitialState(),
  on(eventsActions.loadEvent, (state, action) => {
    const newState = {...adapter.upsertMany(Object.values(action.payload.sponsors), state)}
    newState.sponsorTypes = !action.payload.sponsorTypes ? {} : makeMapFromListOfObjectsAndKey(action.payload.sponsorTypes, 'id')
    return newState
  }),
  on(eventsActions.unloadEvent, (state) => ({ ...makeInitialState() })),
  on(performerActions.changeTableFilters, (state, { filterType }) => ({...state, sponsorFilterType: filterType }))
)

export const sponsorsFeature = {
  name: 'sponsors',
  reducer: sponsorsReducer,
  selectSponsorsState: (state) => state.sponsors as SponsorsState,
  selectEntities: (state) => sponsorsFeature.selectSponsorsState(state).entities,
}

export const sponsorsStateSelector = (state) => state.sponsors as SponsorsState